import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_result = _resolveComponent("a-result")!

  return (_openBlock(), _createBlock(_component_a_result, {
    status: "404",
    title: "Lỗi 404",
    "sub-title": "Trang này không tồn tại"
  }, {
    extra: _withCtx(() => [
      _createVNode(_component_router_link, {
        to: { name: _ctx.RouteName.TOP }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, { type: "primary" }, {
            default: _withCtx(() => [
              _createTextVNode("Về trang chủ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _: 1
  }))
}